<template>
    <div>
        <AppHeader />
        <div class="changelog">
            <h1>Changelog</h1>

            <div class="versao">
                <h2>v.7</h2>
                <p class="data">04/11/2021</p>
                <p class="subtitle">Novidades:</p>
                <p class="descricao">
                    - Agora é possível ordenar as vistorias na lista de vistorias por Id,
                    em ordem crescente e decrescente.
                </p>
                <p class="descricao">- Header da lista de vistorias agora é fixo.</p>
                <p class="subtitle">Correção de bugs:</p>
                <p class="descricao">
                    - Mudança de quantidade de pneus não buga mais a vistoria.
                </p>
                <p class="descricao">
                    - Correção do bug onde botão de reenviar e abrir PDF não estavam
                    aparecendo.
                </p>
            </div>
            <div class="versao">
                <h2>v.6</h2>
                <p class="data">14/10/2021</p>
                <p class="subtitle">Novidades:</p>
                <p class="descricao">- Avarias - Unidas adicionadas ao vex-web.</p>
                <p class="descricao">
                    - Bloqueio de entrada por navegadores não homologados.
                </p>
                <p class="descricao">- Mudanças no layout e cores de botões.</p>
                <p class="descricao">- Mudança de font-family para Roboto.</p>
                <p class="descricao">
                    - Nova tela de bloqueio de acesso por desktop ou naveagadores não
                    homologados.
                </p>
                <p class="subtitle">Correção de bugs:</p>
                <p class="descricao">
                    - Correção de bug na lista de vistorias (agora as vistorias de outros
                    tokens não aparecem mais uns nos outros).
                </p>
                <p class="descricao">
                    - Vistorias já feitas não apareciam na lista de vistorias após troca
                    de token.
                </p>
                <p class="descricao">
                    - Remoção de faixa preta na câmera de dispositivos com tela menor.
                </p>
                <p class="descricao">
                    - Bug que causava travamento no questionário corrigido.
                </p>
            </div>
            <div class="versao">
                <h2>v.5</h2>
                <p class="data">30/07/2021</p>
                <p class="subtitle">Melhorias:</p>
                <p class="descricao">- Melhoria na sincronização de vistorias.</p>
                <p class="subtitle">Correção de bugs:</p>
                <p class="descricao">
                    - Não estava sendo possivel iniciar vistorias no iPhone.
                </p>
            </div>

            <div class="versao">
                <h2>v.4</h2>
                <p class="data">27/07/2021</p>
                <p class="subtitle">Novidades:</p>
                <p class="descricao">
                    - Opção de transmitir a vistoria assim que salva-la.
                </p>
                <p class="descricao">
                    - Botão para visualizar o PDF da vistoria na lista de vistorias.
                </p>
                <p class="subtitle">Melhorias:</p>
                <p class="descricao">
                    - Tratamento nas vistorias locais, após a sincronização das mesmas.
                </p>
            </div>

            <div class="versao">
                <h2>v.3</h2>
                <p class="data">15/07/2021</p>
                <p class="subtitle">Novidades:</p>
                <p class="descricao">- Novo status de erro na lista de vistorias.</p>
                <p class="subtitle">Correção de bugs:</p>
                <p class="descricao">
                    - Redução da qualidade das imagens a fim de tornar as vistorias
                    menores, evitando o bug de carregamento infinito na hora da
                    transmissão.
                </p>
                <p class="descricao">
                    - Correção do bug onde o ID da Vistoria saia no número do contrato
                    dentro do PDF.
                </p>
                <p class="descricao">
                    - Campo Km Odometro agora só aceita números e foi limitado a 8
                    dígitos.
                </p>
            </div>

            <div class="versao">
                <h2>v.2</h2>
                <p class="data">24/02/2021</p>
                <p class="descricao">
                    - Jogando o arquivo getDate para pasta helper, para ficar mais
                    reutilizavel e organizado.
                </p>
            </div>

            <div class="versao">
                <h2>v.1</h2>
                <p class="data">24/02/2021</p>
                <p class="descricao">- Implementando changelog para o app.</p>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";

export default {
    components: {
        AppHeader: Header,
    },
};
</script>

<style scoped>
.changelog {
    padding: 10px;
    font-family: "Roboto";
}
.changelog h1 {
    font-size: 15pt;
    font-weight: bold;

    margin-bottom: 20px;
}
.versao {
    border: 1px solid rgb(179, 177, 177);
    padding: 10px;
    background-color: #f9f9f9;
    margin-bottom: 10px;
}
.versao h2 {
    font-size: 12pt;
    font-weight: bold;
}
.versao .data {
    color: gray;
}
.versao .descricao {
    font-size: 10pt;
}
.versao .subtitle {
    font-size: 11pt;
    font-weight: 500;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #343a40;
    height: 60px;
}

.header img,
.header .dropdown {
    margin: 5px;
}

.header img,
.header .dropdown {
    margin: 10px;
}
</style>
